/** Business/owner branding on asset_owner_profiles — not the user's personal avatar. */
export const OWNER_LOGO_KEYS = [
  'logo_url',
  'logoUrl',
  'logo',
  'brand_logo',
  'brandLogo',
  'business_logo',
] as const;

export function ownerLogoFromRecord(record: Record<string, unknown>): string | null {
  for (const key of OWNER_LOGO_KEYS) {
    const v = record[key];
    if (typeof v !== 'string') {
      continue;
    }
    const trimmed = v.trim();
    if (!trimmed || trimmed.startsWith('data:')) {
      continue;
    }
    return trimmed;
  }
  return null;
}
